import Image from "@/components/Image";
import { getGrocery } from "@/services";
import useReq from "@/utils/useReq";
import classNames from "classnames";
import { useMemo } from "react";
import styles from "./index.module.less";

export default function ConsultationQr({
  leads_entrance = "other",
  className,
}: {
  leads_entrance?: string;
  className?: string;
} = {}) {
  const { data: config } = useReq(
    async () => {
      const config: {
        qrcodeList: { leads_entrance: string; img: IGroceryUploadFile[] }[];
        qrcodeTopTxt: string;
        qrcodeBottomTxt: string;
      } = await getGrocery("company-consult-v2");

      return config;
    },
    {
      cacheKey: "grocery:company-consult-v2",
    }
  );

  const qrcodeImg = useMemo(() => {
    if (!config) {
      return;
    }

    const qrcode = config?.qrcodeList?.find(
      (item) => item.leads_entrance === leads_entrance
    )?.img[0].url;

    return (
      qrcode ||
      config?.qrcodeList?.find((item) => item.leads_entrance === "other")
        ?.img[0].url
    );
  }, [config, leads_entrance]);

  return (
    <div
      className={classNames(className, styles.qrcode)}
      data-gd-expose="dialog_expose"
      data-dialog-title="企业咨询二维码"
    >
      <div className={styles.title}>
        {config?.qrcodeTopTxt || "为企业购买，在线咨询"}
      </div>
      <Image
        src={
          qrcodeImg ||
          "https://grocery-cdn.huaban.com/file/30689520-32e3-11ef-a876-2923bb6ac4c7.png"
        }
        width={180}
        height={180}
        alt="二维码"
      />
      <div className={styles.desc}>{config?.qrcodeBottomTxt}</div>
    </div>
  );
}
